import registerServiceworker from 'owa-serviceworker-cache/lib/registerServiceworker';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import { SWAppName } from 'data/lib/mini-app-constants';
import {
    getSkipRegistrationReason,
    SkipRegistrationReasons,
} from './utils/getSkipRegistrationReason';

export const SwDatapointName = 'RegisterServiceWorker';
export const SuccessReason = 'success';

export default async function _initializeServiceWorker(
    windowObj: Window,
    serverAppName: SWAppName
) {
    const dp = new PerformanceDatapoint(SwDatapointName);
    const serviceWorkerContainer: ServiceWorkerContainer =
        windowObj.navigator != null && windowObj.navigator.serviceWorker;

    let skipRegistrationReason: string;
    let registerError: Error;

    if (serviceWorkerContainer) {
        skipRegistrationReason = getSkipRegistrationReason();
        if (!skipRegistrationReason) {
            try {
                await registerServiceworker(windowObj, serverAppName, dp);
            } catch (e) {
                registerError = e;
            }
        } else if (
            serviceWorkerContainer.controller != null &&
            serviceWorkerContainer.getRegistrations
        ) {
            serviceWorkerContainer
                .getRegistrations()
                .then((registrations: ServiceWorkerRegistration[]) => {
                    for (let i = 0; i < registrations.length; ++i) {
                        registrations[i].unregister();
                    }
                });
        }
    } else {
        skipRegistrationReason = SkipRegistrationReasons.SwSupportUnavailable;
    }

    dp.addCustomData([skipRegistrationReason || SuccessReason]);
    if (registerError) {
        dp.endWithError(DatapointStatus.ClientError, registerError);
    } else if (skipRegistrationReason) {
        dp.endWithError(DatapointStatus.ServerError);
    } else {
        dp.end();
    }
}
